import {
  FETCH_CARE_PLAN_AUDIT,
  FETCH_CARE_PLAN_AUDIT_SUCCESS,
  FETCH_CARE_PLAN_AUDIT_FAILURE,
  RESET_CARE_PLAN_AUDIT,
} from "./constants";

/**
 * payload: { locationId, filters, append? }
 * filters from schema.buildCarePlanAuditFilters
 */
export const fetchCarePlanAudit = (payload, onSuccess) => ({
  type: FETCH_CARE_PLAN_AUDIT,
  payload,
  onSuccess,
});

/** payload: { response, append } */
export const fetchCarePlanAuditSuccess = (payload) => ({
  type: FETCH_CARE_PLAN_AUDIT_SUCCESS,
  payload,
});

export const fetchCarePlanAuditFailure = (payload) => ({
  type: FETCH_CARE_PLAN_AUDIT_FAILURE,
  payload,
});

export const resetCarePlanAudit = () => ({
  type: RESET_CARE_PLAN_AUDIT,
});
